<template>
  <div class="sold-out main-container">
    <div>
      <img src="@/assets/images/course/xiajia@2x.png" />
      <div class="tip">
        <span>啊哦，你来晚了，该{{ name }}不存在或者已下架～</span>
        <a @click="goToList">看看其他{{ name }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseSoldOut",
  props: {
    name: {
      type: String,
      default: "课程",
    },
    routerName: {
      type: String,
    },
  },
  methods: {
    goToList() {
      if (this.routerName) {
        this.$router.push({ name: this.routerName });
      } else {
        let nav = this.$store.state.navigates.filter(
          n => n.id == this.$route.query.nav,
        )[0];
        if (nav) {
          nav = { ...nav };
          let url = nav.url;
          if (url.indexOf("?") < 0) {
            url += "?";
          } else {
            url += "&";
          }
          url += "nav=" + nav.id;
          this.$router.push({ path: url });
        } else {
          this.$router.push({ name: "Course" });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sold-out {
  background-color: white;
  text-align: center;
  margin-top: 30px;
  box-sizing: border-box;
  padding-top: 118px;
  height: calc(100vh - 70px - 125px - 30px);

  img {
    width: 259px;
    margin-bottom: 12px;
    vertical-align: middle;
  }

  .tip {
    height: 17px;
    font-size: 16px;
    color: rgba(26, 26, 26, 1);
    line-height: 18px;

    a {
      margin-left: 15px;
      color: $primary-color;
      cursor: pointer;
    }
  }
}
</style>
